import { createFileRoute } from "@tanstack/react-router";
import FactureForm from "@/features/ventes/components/facturation/FactureForm";

export const Route = createFileRoute("/_app/ventes/facturation/create")({
  staticData: {
    title: "Nouvelle facture",
    showInBreadcrumb: true,
  },
  component: FactureForm,
});
